import Cookies from 'js-cookie'



const TokenKey = 'vue_admin_template_token_shop'
export function setToken(token) {
    //return Cookies.set(TokenKey, token)
    return Cookies.set(TokenKey, token,{ expires: 1 });//有效期1天
}
export function getToken() {

    //使用时更新cookie的过期时间
    let t = Cookies.get(TokenKey);
    if(t != undefined){
        let token = JSON.parse(t);
        Cookies.set(TokenKey, token,{ expires: 1 });//有效期1天
        //console.log('update cookie over');
    }

    return Cookies.get(TokenKey)
}
export function getToken2() {
    return Cookies.get(TokenKey);
}
export function removeToken() {
    return Cookies.remove(TokenKey)
}




export function setTokenBykey(key,token) {
    return Cookies.set(key, token)
}
export function getTokenBykey(key) {
    return Cookies.get(key)
}
export function removeTokenBykey(key) {
    return Cookies.remove(key)
}





export function getStaffDTO() {
    let staffDTO = JSON.parse(getToken());
    return staffDTO;
}

export function getStaffCode() {
    let staffDTO = JSON.parse(getToken());
    return staffDTO.staffCode;
}

export function getGovernmentCode() {
    let staffDTO = JSON.parse(getToken());
    return staffDTO.governmentCode;
}


export function getUrlParams(name) { // 不传name返回所有值，否则返回对应值
    var url = window.location.href;
    if (url.indexOf('?') == -1) { return false; }else{
        url=url.split('?')[1]
    }
    var nameres={}
    var list=url.split('&');
    for(var i in list){
        var label=list[i].split('=')[0]
        var value=list[i].split('=')[1]
        nameres[label]=value
    }
    // 返回结果
    return name?nameres[name]:nameres;
}


//获取自动收费规则
export function getChargeTime() {
    return '月';
}


/**
 * 替换掉部分字符串
 * */
export function replaceStr(name) {

    var str = name.replaceAll("super","")//超级管理员
        .replaceAll("admin","")//系统管理员
        .replaceAll("Gov","")//政府
        .replaceAll("Reg","")//监管者(regulator)
        .replaceAll("Ins","")//机构
        .replace("Zone","");//组织

    var host = window.location.host;
    if(host=='shop-adm.ynnqo.com:547'){
        str = str.replaceAll("社区养老","社区康复")
        str = str.replaceAll("居家养老","居家康复")
        str = str.replaceAll("老人","儿童");
        str = str.replaceAll("子女","家人");
    }
    if(host=='shop-adm.ynnqo.com:558'){
        //str = str.replaceAll("老人管理","服务对象管理")
        //str = str.replaceAll("居家养老","居家及上门护理")
        //str = str.replaceAll("老人","服务对象");
        //str = str.replaceAll("子女","家人");
    }

    return str;

}
